import axiosInstance from "../../lib/axiosInstance";

/**
 * Organisation membership + active-org for the developer app.
 *
 * Uses the developer-native pair (`/developer/organisations`), not the accounts
 * pair (`/auth/organisations`). Both list the same `vcs_user_organisations`
 * rows, but they key off different identities and persist the choice in
 * different places:
 *
 *   /auth/organisations       — VCS_SESSION cookie, writes
 *                               `vcs_user_sessions.active_organisation_id`
 *   /developer/organisations  — JWT bearer `sub`, writes
 *                               `vcs_developers_active_org`
 *
 * This app authenticates its data endpoints by bearer, so the developer pair is
 * the one whose active org a request can actually see.
 */

export const listOrganisations = async () => {
  const res = await axiosInstance.get("/developer/organisations");
  // { organisations: [{ organisation_id, name, role, is_active }], active_organisation_id }
  return res.data;
};

export const setActiveOrganisation = async (organisationId) => {
  const res = await axiosInstance.post("/developer/organisations/active", {
    organisation_id: organisationId,
  });
  return res.data; // { active_organisation_id }
};
